<template>
  <el-select
    ref="innerSelect"
    v-model="selection"
    popper-class="search-singer"
    multiple
    filterable
    remote
    default-first-option
    v-select-sortable
    :trigger-on-focus="false"
    :placeholder="placeholder"
    :disabled="disabled"
    :remote-method="searchSingers"
    :loading="searchSingerLoading"
    @change="handleChange"
  >
    <slot name="dropdown" />
    <template v-slot:empty>
      <slot name="dropdown" />
    </template>
    <el-option v-for="item in singerOptions" :key="item.singerId" :label="item.label" :value="item">
      <div class="option-item">
        <div class="img-wrap">
          <img v-if="item.photoUrl" :src="item.photoUrl" alt="艺人图" class="img">
        </div>
        <div class="info">
          <p>{{ item.singerName }}</p>
          <p>{{ areaMap[item.area] }}</p>
        </div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import axios from 'axios'
import actorService from '@/api/actor.js'
import { areaMap } from '@/utils/constants'

const CancelToken = axios.CancelToken

export default {
  name: 'SearchSingerComp',
  props: {
    value: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    defaultOptions: {
      type: Array,
      default() {
        return []
      }
    },
    placeholder: {
      type: String,
      default: '请输入关键词搜索'
    }
  },
  data() {
    return {
      areaMap,
      singerOptions: [],
      selection: [],
      searchSingerLoading: false
    }
  },
  watch: {
    defaultOptions(newVal) {
      this.singerOptions = newVal
    },
    value(newVal) {
      this.selection = newVal
    }
  },
  create() {

  },
  mounted() {
    this.selection = this.value
    this.singerOptions = this.defaultOptions
  },
  methods: {
    focus() {
      this.$refs.innerSelect.focus()
    },
    handleChange(selection) {
      this.$emit('update:value', selection)
      this.$emit('change', selection)
    },

    searchSingers(query) {
      if (query !== '') {
        const source = CancelToken.source()
        if (this.requestToken) {
          this.requestToken.cancel('search singer cancel old request')
        }
        this.requestToken = source

        this.searchSingerLoading = true
        actorService.searchActor({
          page: 0,
          num: 100,
          keyWord: query
        }, { cancelToken: source.token }).then(resp => {
          this.singerOptions = resp.list.map(singerObj => {
            const value = singerObj.singerName
            return {
              value,
              label: value,
              isOfficial: 1,
              ...singerObj,
            }
          })
        }).catch(error => {
          // console.error(error)
          if (axios.isCancel(error)) {
            return console.log('取消请求')
          }
          this.$message({
            type: 'error',
            message: '搜索艺人异常: ' + error.message,
            duartion: 5000
          })
        }).finally(_ => {
          this.searchSingerLoading = false
        })
      }
    }
  }
}
</script>

<style lang="scss">
.search-singer {
  .el-select-dropdown__item {
    height: 56px;
    padding: 8px 0 8px 16px;
    line-height: 1.5;
  }
  .option-item {
    display: flex;

    .img-wrap {
      width: 40px;
      height: 40px;
      // border: 1px solid #ccc;
      box-shadow: 0 0 5px #ccc;
      background: url('~@/assets/images/actor.png') 50% no-repeat;
    }

    .img {
      width: 40px;
      height: 40px;

      background: url('~@/assets/images/actor.png') 50% no-repeat;
    }

    .info {
      margin-left: 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
